import { useMemo } from 'react';

import { isHtmlHebrew } from '../../util/language';

export const useIsRtlHtml = (html: string) => {
  return useMemo(() => isHtmlHebrew(html), [html]);
};
